import Route from "vue-routisan";
import vuex from "src/vuex";
import isAuthenticated from "./middlewares/isAuthenticated";
import isFintech from "./middlewares/isFintech";
import hasFinancierPermission from "@/http/routes/middlewares/hasPermission/hasFinancierPermission";

Route.group({}, () => {

  Route.group({prefix: "fintech", beforeEnter: [isAuthenticated, hasFinancierPermission, isFintech]}, () => {
    Route.group({prefix: "finance"}, () => {

      Route.redirect("/", to => {
        return {name: "fintech.dashboard"};
      });

      Route.view("/dashboard", () =>
        import(/* webpackChunkName: "fintech" */ "src/resources/views/finance/fintech/Dashboard/Dashboard.vue")
      ).name("fintech.dashboard");

      Route.view("/panel_notification", () =>
        import(/* webpackChunkName: "fintech" */ "src/resources/views/finance/fintech/panel/PanelNotificationFinanceList")
      ).name("fintech.finance.panel_notification")

      Route.view("/settings", () =>
        import(/* webpackChunkName: "fintech" */ "src/resources/views/finance/fintech/setting/Settings.vue")
      ).name("fintech.finance.settings")

      Route.group({prefix: "quotation"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "fintech" */ "src/resources/views/finance/fintech/Quotation/QuotationList")
        ).name("fintech.quotation")

        Route.view("/:id", () =>
          import(/* webpackChunkName: "fintech" */ "src/resources/views/finance/fintech/Quotation/new/QuotationDetails")
        ).name("fintech.quotation_details")

        Route.view("/anticipation_fatura/:fatura_id", () =>
          import(/* webpackChunkName: "fintech" */ "src/resources/views/finance/fintech/Quotation/Anticipation/AnticipationFatura")
        ).name("fintech.anticipation_fatura")

        // Route.view("/quotation_secret", () =>
        //   import(/* webpackChunkName: "fintech" */ "src/resources/views/fintech/Quotation/QuotationSecret")
        // ).name("fintech.quotation_secret")

        Route.view("/solicitation/chat/:solicitation_id", () =>
          import(/* webpackChunkName: "fintech" */ "src/resources/views/finance/fintech/Quotation/SolicitationChat")
        ).name("fintech.solicitation_chat")

        Route.view("/anticipation_fatura/verification/:cte_id", () =>
          import(/* webpackChunkName: "fintech" */ "src/resources/views/finance/fintech/Quotation/Anticipation/AnticipationFaturaVisualVerification")
        ).name("fintech.anticipation_fatura_visual")
      });

      Route.group({prefix: "user"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "shipper" */ "src/resources/views/finance/fintech/user/UserList")
        ).name("fintech.user")

        Route.view("/create", () =>
          import(/* webpackChunkName: "shipper" */ "src/resources/views/finance/fintech/user/UserCreate")
        ).name("fintech.user_create")

        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "shipper" */ "src/resources/views/finance/fintech/user/UserUpdate")
        ).name("fintech.user_update")

      });

    });
  });
});

export default Route.all();
